import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RouterService } from './services/router.service';

export const countryGuard: CanActivateFn = (route, state) => {
  
  const routerService = inject(RouterService);
  
  let country = route.params['country'];
  if(!country){
    country = routerService.getCountry();
  }

  const currentUrl = state.url;

  if (country) {

    if (!currentUrl.startsWith(`/${country}`)) {
      const newUrl = currentUrl != "/" ? `/${country}${currentUrl}`: `/${country}`; 
      const router = inject(Router);
      router.navigateByUrl(newUrl);
      return false;
    }else{
      return true;
    }
  }

  return true;
};
